async function generateHmacSignature(data, url) {
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  const nonce = Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  const bodyString = data ? JSON.stringify(data) : "";

  const payload = `${timestamp}${nonce}${bodyString}`;

  const encoder = new TextEncoder();
  const keyBuffer = encoder.encode(process.env.REACT_APP_SECRET_KEY);
  const dataBuffer = encoder.encode(payload);
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBuffer,
    {
      name: "HMAC",
      hash: "SHA-256",
    },
    false,
    ["sign"]
  );

  const signatureBuffer = await window.crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    dataBuffer
  );

  const signatureHex = Array.from(new Uint8Array(signatureBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return {
    "x-timestamp": timestamp,
    "x-nonce": nonce,
    "x-signature": signatureHex,
  };
}

export default generateHmacSignature;
